<template>
    <div>
        <collegeBanner></collegeBanner>
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <CollegeSideNavLayout></CollegeSideNavLayout>
                </div>
                <div class="col-md-9">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h1>Shortlisted Applications</h1>
                                        </div>
                                    </div>
                                </div>
                                <div class="row padd-top-10">
                                    <div class="col-md-12" v-if="shortlistedApp.length">
                                        <div class="col-md-4" v-for="job in shortlistedApp">
                                            <div class="job-box">
                                                <div class="jb-com-icon">
                                                    <router-link :to="{path: '/profile?slug=' + job.comp_slug}">
                                                        <img v-bind:src="job.logo" :alt="job.name"/>
                                                    </router-link>
                                                </div>
                                                <div class="jb-com-name">
                                                    <router-link :to="{path: '/profile?slug=' + job.org_slug}">
                                                        {{ job.name }}
                                                    </router-link>
                                                </div>
                                                <span class="stamp is-nope" v-if="job.is_closed">Recruitment Completed</span>
                                                <div class="jb-job-title">
                                                    <span v-html="job.title"></span>
                                                    <div v-if="job.is_exclusive" class="tooltip-main labelImg display-inline-block">
                                                        <img src="images/all-jobs/exclusive.png" width="30" hspace="5"/>
                                                        <span class="tooltiptext tooltip-bottom">Exclusive</span>
                                                    </div>
                                                </div>
                                                <div class="jb-job-location">
                                                    <i class="fas fa-map-marker-alt"></i> {{ job.location }}
                                                </div>
                                                <div class="jb-job-positions">
                                                    {{job.positions}} Positions
                                                </div>
                                                <div class="jb-view-details">
                                                    <router-link :to="{path: '/detail?id=' + job.slug}">
                                                        View <span v-if="job.job_type == 'Jobs'">Job</span><span v-else>Internship</span> Detail
                                                    </router-link>
                                                    <div v-if="job.filling_soon && !job.is_closed" class="tooltip-main labelImg display-inline-block">
                                                        <img src="images/all-jobs/filling-soon.png" width="15" hspace="5"/>
                                                        <span class="tooltiptext tooltip-bottom">Filling Soon</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 text-center" v-else>
                                        <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                                        <h2 class="no-data-found">No Applications Shortlisted Yet</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CollegeSideNavLayout from './../../components/CollegeSideNavLayout.vue'
    import collegeBanner from './../../components/collegeBanner.vue'
    import axios from 'axios'
    import toastr from "../../../public/js/toastr";
    import {requestHeaders} from "../../_helpers/apiHelper";

    export default {
        components: {
            CollegeSideNavLayout,
            collegeBanner
        },
        data: function () {
            return {
                shortlistedApp: [],
            }
        },
        mounted() {
            this.getShortlistedAppList();
        },
        methods: {
            getShortlistedAppList(){
                var t = this;
                var url = this.$store.getters.getDomain;

                axios.post(`${url}api/v2/candhome/shortlisted-applications`, "", {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200){
                        t.shortlistedApp = response['data']['response']['shortlisted'];
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .jb-job-location > div {
        display: inline-block;
        margin: 0px 2px;
    }
    .copy-to-clipboard2 {
        color: #555;
        cursor: pointer;
        padding: 10px 15px;
        margin: 0px 5px;
        border: 1px solid #ddd;
        border-radius: 10px 0px 10px 0;
    }
    .copy-to-clipboard2:hover{
        border-radius: 0px 0px 0px 0;
        -webkit-transition: .5s all;
        transition: .5s all;
    }
</style>